/** @format */

import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { _$, Drawer, Form, FormItem, Input, Transfer, Message } from 'kpc-react'
import { ContactGroupDrawerProps, updateGroupProps, initConstactGroupForm } from './constants'
import _ from 'lodash'
import API from 'src/api/ApiContacts'
import { request } from 'src/utils'

const ContactGroupDrawer: React.FC<ContactGroupDrawerProps> = ({
  className,
  visible,
  closeDrawer,
  curGroup,
  userList
}) => {
  const [formValues, setFormValues] = useState<updateGroupProps>(initConstactGroupForm)
  const formRef = useRef<any>()
  // 初始化
  useEffect(() => {
    if (visible) {
      if (curGroup.usrgrpid) {
        const { name, description, contactIds } = curGroup
        setFormValues({
          ...formValues,
          Name: name,
          Description: description,
          UserIdList: contactIds
        })
      }
    } else {
      // 关闭：清空form
      setFormValues(initConstactGroupForm)
    }
  }, [visible])

  // 修改formValues
  const changeFormValues = values => {
    setFormValues({
      ...formValues,
      ...values
    })
  }

  // 提交
  const formSubmit = async () => {
    const validate = await formRef?.current?.validate()
    if (validate) {
      const params = _.cloneDeep(formValues)
      params.UserIdList = params.UserIdList.map(({ userid }) => userid || '')
      if (params.UserIdList.length) {
        const url = curGroup.usrgrpid ? API.updateUserGroup : API.createUserGroup
        if (curGroup.usrgrpid) {
          params.UserGrpId = curGroup.usrgrpid
        }
        const result = await request(url, {
          method: 'POST',
          data: params
        })
        const { code, message } = result
        if (code === 'Success') {
          Message.success(message)
          closeDrawer(true)
        }
      } else {
        Message.error(_$('联系组需至少包含一个联系人'))
      }
    }
  }

  return (
    <Drawer
      width={700}
      value={visible}
      title={curGroup?.usrgrpid ? _$('修改联系组') : _$('新建联系组')}
      onClose={() => {
        closeDrawer()
      }}
      cancel={() => {
        closeDrawer()
      }}
      disabledOk={formValues?.UserIdList?.length < 1}
      ok={() => {
        formSubmit()
      }}
    >
      <div className={className}>
        <Form starOnRequired={true} ref={formRef} labelWidth={100}>
          <FormItem
            label={_$('联系组名称')}
            value={formValues.Name}
            rules={{
              required: true,
              userName: true
            }}
          >
            <Input
              value={formValues.Name}
              on$change-value={(_c, value) => {
                changeFormValues({
                  Name: value
                })
              }}
            />
          </FormItem>
          <FormItem
            label={_$('描述')}
            value={formValues.Description}
            rules={{
              maxLength: 100
            }}
          >
            <Input
              value={formValues.Description}
              on$change-value={(_c, value) => {
                changeFormValues({
                  Description: value
                })
              }}
            />
          </FormItem>
          <FormItem label={_$('联系人')} value={formValues.UserIdList}>
            <Transfer
              data={userList}
              value={formValues.UserIdList}
              b-label={(data, index, type) => <p>{data.name}</p>}
              filter={(data, value) => {
                return data.name.includes(value)
              }}
              filterable
              keyName="userid"
              on$change-value={(_c, value) => {
                if (!value.length) {
                  Message.warning(_$('联系组需至少包含一个联系人'))
                }
                changeFormValues({
                  UserIdList: value
                })
              }}
            ></Transfer>
          </FormItem>
        </Form>
      </div>
    </Drawer>
  )
}
export default styled(ContactGroupDrawer)``
